module.exports = __webpack_public_path__ + "static/media/Levin_Range_Seat_2 Lighting 2.de382df9.jpg";